const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9 \-_/().&,#'+]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const formElementFields = [
  {
    id: "name",
    label: "Material Name",
    placeHolder: "",
    type: "text",
    md: 12,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isRequired: true,
  },
  {
    id: "rate",
    label: "Rate",
    placeHolder: "Enter rate",
    type: "text",
    patternAllowed: patternConstant?.PRICE,
    isRequired: true,
    // firstColmd: 1.5,
    md: 6,

  },
  {
    id: "volume",
    label: "Volume",
    placeHolder: "Enter volume",
    type: "text",
    patternAllowed: patternConstant?.PRICE,
    isRequired: true,
    // firstColmd: 1.5,
    md: 6,
  },
];